import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { AssessmentService } from 'src/app/core/services/assessment.service';
import { StorageService } from 'src/app/core/services/storage.service';

@Component({
  selector: 'app-progress-detail-chart',
  templateUrl: './progress-detail-chart.component.html',
  styleUrls: ['./progress-detail-chart.component.css']
})
export class ProgressDetailChartComponent implements OnInit {
  progressDetails: any;
  assessmentLabels = ['Not Answered', 'Answered'];
  assessmentArabicLabels = ['بلا جواب', 'أجاب'];
  assessmentData: any = [];
  assessmentBackgrnd = ['#FFF', '#A5DCE5'];
  assessmentBorder = ['#A5DCE5', '#A5DCE5'];
  assessmentTitle: any;

  quesBackgrnd = ['#FFF', '#A5DCE5'];
  quesBorder = ['#A5DCE5', '#A5DCE5'];

  progressText: any;
  isArabic!: boolean;

  parentPath!: any;
  selectedQuestionStateData!: any;

  constructor(private route: Router, private assessmentService: AssessmentService, private storageService: StorageService,
    private location: Location) {
  }

  ngOnInit(): void {
    const state: any = this.location.getState();
    this.parentPath = state?.parent;
    this.selectedQuestionStateData = state?.selectedQuestionState;

    if (this.selectedQuestionStateData) {
      this.storageService.setSessionStorageData('selectedQuestionState', this.selectedQuestionStateData);
    }
    this.isArabic = this.storageService.getSessionStorageData('isArabic');
    this.progressDetails = this.assessmentService.getProgressDetailsData();
    // console.log('check: ', this.progressDetails);
    if (this.progressDetails == undefined) {
      this.goToLastPage();
    } else {
      this.assessmentData = [this.progressDetails?.notAnswered, this.progressDetails?.totalAnswers];
      this.assessmentTitle = this.isArabic ? 'عدد الأسئلة' : 'No. of Questions';
      this.progressText = this.isArabic ? (this.progressDetails.questionnaireProgress + '% :' + ' إنجاز التقييم :')
        : ('Assessment Progress : ' + this.progressDetails.questionnaireProgress + '%');
    }

  }

  goToLastPage() {
    if (this.parentPath && this.parentPath == "submit-assessment" &&
      this.selectedQuestionStateData?.questionnaireType) {
      this.route.navigate(['submit-assessment'],
        {
          queryParams: {
            questionnairetype: this.selectedQuestionStateData?.questionnaireType,
            revisittype: 'return'
          }
        });
    }
    else if (this.parentPath && this.parentPath == "executor-dashboard") {
      this.route.navigate(['executor-dashboard/progress-tracker']);
    }
    else {
      this.location.back();
    }

  }

  calculatePercentage(answeredQues: any, totalCount: any) {
    let percentage;
    if (answeredQues == 0 || totalCount == 0) {
      percentage = 0;
    } else {
      //  percentage = Math.floor(Number((answeredQues / totalCount) * 100));
      percentage = (Number((answeredQues / totalCount) * 100)).toFixed(2);
    }
    return percentage;
  }

}
